var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "jobviewcontainer no-gutters mx-0" },
    [
      _c(
        "b-col",
        {
          class: _vm.isMobile ? "col-12" : "col-5",
          staticStyle: { display: "flex", "flex-direction": "column" },
        },
        [
          _c("JobResultList", {
            attrs: {
              jobPostings: _vm.jobPostings,
              infiniteScrollDistance: 1000,
              useSavedAdvert: _vm.useSavedAdvert,
              activeIndex: _vm.activeIndex,
            },
            on: {
              setSelectedJobPosting: function ($event) {
                return _vm.setSelectedJobPosting($event)
              },
              toggleSavedAdvert: function ($event) {
                return _vm.toggleSavedAdvert($event)
              },
              searchForMore: function ($event) {
                return _vm.searchForMore()
              },
              setActiveIndex: function ($event) {
                return _vm.setActiveIndex($event)
              },
            },
          }),
          _vm.isSearching === true
            ? _c(
                "div",
                { staticClass: "spinner-box d-flex justify-content-center" },
                [_c("b-spinner")],
                1
              )
            : _vm._e(),
          _c("div", { staticClass: "list-box-filler d-flex" }),
        ],
        1
      ),
      _c(
        "b-col",
        { staticClass: "col-7" },
        [
          _vm.selectedJobPosting !== undefined
            ? _c("JobDetailsView", {
                attrs: {
                  selectedJobPosting: _vm.selectedJobPosting,
                  useSavedAdvert: _vm.useSavedAdvert,
                  jobmatch: _vm.jobmatch,
                  content: _vm.content,
                  jobApplicationAccess: _vm.jobApplicationAccess,
                },
                on: {
                  setSelectedJobPosting: function ($event) {
                    return _vm.setSelectedJobPosting($event)
                  },
                  toggleSavedAdvert: function ($event) {
                    return _vm.toggleSavedAdvert($event)
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }